export const TEAM = {
  "staff": [
    {
      "name": "Tomasz",
      "lastName": "Durbas",
      "position": "Trener",
      "src": "durbas.jpg"
    }
  ],
  "goalkeepers": [
    {
      "name": "Karol",
      "lastName": "Zawiślak",
      "number": 1,
      "src": ""
    }
  ],
  "defenders": [
    {
      "name": "Kacper",
      "lastName": "Pikul",
      "number": 2,
      "src": ""
    },
        {
      "name": "Mateusz",
      "lastName": "Cygan",
      "number": 10,
      "src": ""
    },
    {
      "name": "Dawid",
      "lastName": "Żurawski",
      "number": 15,
      "src": ""
    },
    {
      "name": "Damian",
      "lastName": "Garncarz",
      "number": 11,
      "src": "garncarz.jpg"
    }
  ],
  "midfielders": [
    {
      "name": "Karol",
      "lastName": "Minorczyk",
      "number": 7,
      "src": "karol.jpg"
    },
        {
      "name": "Tomasz",
      "lastName": "Zieliński",
      "number": 21,
      "src": "ziele.jpg"
    },
    {
      "name": "Szymon",
      "lastName": "Świder",
      "number": 17,
      "src": ""
    },
    {
      "name": "Bartosz",
      "lastName": "Pikul",
      "number": 20,
      "src": "bPikul.jpg"
    }
  ],
  "attackers": [
    {
      "name": "Mariusz",
      "lastName": "Pyzik",
      "number": 9,
      "src": "mariusz.jpg"
    },
        {
      "name": "Szczepan",
      "lastName": "Urban",
      "number": 8,
      "src": ""
    }
  ]
}